import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useProjectPurchaseOrders = (projectId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["purchase_orders", projectId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("purchase_orders")
        .select("id, number, description, total_amount, status, vendor_id, vendors(name), created_at")
        .eq("project_id", projectId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
    enabled: !!user && !!projectId,
  });
};

export const useProjectJobOrders = (projectId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["job_orders", projectId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("job_orders")
        .select("id, number, description, amount, status, created_at")
        .eq("project_id", projectId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
    enabled: !!user && !!projectId,
  });
};

export const useProjectChangeOrders = (projectId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["change_orders", projectId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("change_orders")
        .select("id, number, description, amount, status, job_order_id, work_order_id, created_at")
        .eq("project_id", projectId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
    enabled: !!user && !!projectId,
  });
};

export const useProjectInvoices = (projectId: string | undefined) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["invoices", "project", projectId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("invoices")
        .select("id, invoice_number, invoice_date, due_date, sent_at, paid_at, payment_reference, payment_method, notes, subtotal, total, amount_paid, status, customer_id, customer_visible, customers(name), created_at")
        .eq("project_id", projectId!)
        .is("deleted_at", null)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
    enabled: !!user && !!projectId,
  });
};
